import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Checkbox from "@mui/material/Checkbox";
import { ListItemText, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ListCheckBox = ({
  listText,
  checked,
  setChecked,
  edit = false,
}) => {
  const { t } = useTranslation("global");

  const handleToggle = (value) => () => {
    const isChecked = checked.some((item) => item.id === value.id);

    if (!isChecked) {
      setChecked((prevChecked) => [...prevChecked, value]);
    } else {
      setChecked((prevChecked) =>
        prevChecked.filter((item) => item.id !== value.id)
      );
    }
  };

  if (!Array.isArray(listText) || listText.length < 1) {
    return (
      <Typography color="primary" variant="body2">
        {t("sendNotifications.noData")}
      </Typography>
    );
  }

  return (
    <List dense sx={edit ? { width: "100%" } : { width: "50%" }}>
      {listText?.map((value) => {
        const labelId = `checkbox-list-secondary-label-${value - 1}`;
        return (
          <ListItem
            key={value.id}
            secondaryAction={
              <Checkbox
                edge="end"
                onChange={handleToggle(value)}
                checked={checked.some((item) => item.id === value.id)}
                inputProps={{ "aria-labelledby": labelId }}
              />
            }
            disablePadding
          >
            <ListItemText
              id={labelId}
              primary={
                <Typography color="primary" variant="body2">
                  {value.idCrm} - {value.name} {value.surnames}
                </Typography>
              }
            />
          </ListItem>
        );
      })}
    </List>
  );
};
